import gql from 'graphql-tag';

const AUCTION_FRAGMENT = gql`
  fragment AuctionFragment on Auction {
    acv_estimates {
      ...AcvEstimatesFragment
    }
    allow_bidding
    auction_lights
    autosell
    basic_color_name
    buyer_info {
      ...BuyerInfoFragment
    }
    can_bid
    can_buy
    can_edit_persistent_proxy
    can_finalize
    can_make_offer
    can_negotiate
    can_proxy_bid
    can_purchase_now
    can_remove_reserve
    class_name
    cylinders
    dealership_claims {
      ...DealershipClaimFragment
    }
    dealership_member_bids {
      ...DealershipMemberBidFragment
    }
    doors
    drivetrain
    end_time
    finalized
    floor_price
    has_active_proxy
    has_viewed_details
    hide_acv_estimate_vdp
    hide_bids_views_vdp
    high_bid
    id
    is_on_watch_list
    is_member_of_selling_dealership
    is_member_of_top_bidding_dealership
    is_primary_seller
    is_primary_top_bidder
    is_private
    is_sealed_bid
    lane_display_name
    make
    make_offer_end_time
    mandated_transport
    max_offer_amount
    min_offer_amount
    model
    my_auction_claim {
      ...MyAuctionClaimFragment
    }
    negotiation_end_time
    negotiation_info {
      ...NegotiationInfoFragment
    }
    odometer
    order_code
    participant
    pending_offer {
      ...PendingOfferFragment
    }
    pickup_city
    pickup_region
    preview_show_start_price
    primary_image {
      ...ImageFragment
    }
    private_auction_make_offer_end_time
    private_auction_phase
    private_lane_id
    proxy_bid {
      ...ProxyBidFragment
    }
    proxy_bid_interval
    purchase_now_enabled
    saved_auction_id
    seller_badge_info
    seller_status {
      ...SellerStatusFragment
    }
    show_reserve
    start_price
    start_time
    status
    status_pills
    style
    trim
    user_lost_top_bid
    user_was_just_outbid
    vin
    year
  }
`;

export default AUCTION_FRAGMENT;
